import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import FooterSmall from "components/Footers/FooterSmall.js";

// views

import Login from "views/auth/Login.js";
import Register from "views/auth/Register.js";
import ForgotPassword from "views/auth/ForgotPassword";
import ResetPassword from "views/auth/ResetPassword";
import secureLocalStorage from "react-secure-storage";

export default function Auth() {

    const settings = secureLocalStorage.getItem("systemSettings");
    const systemSettings = JSON.parse(settings);
    const backgroundColor=systemSettings?.mainBackground??" bg-qt "

  return (
    <>
      {/*<Navbar transparent />*/}
      <main style={{backgroundColor}}>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className={`absolute top-0 w-full h-full ${backgroundColor} bg-no-repeat bg-full`}
          // style={{
          //   backgroundImage:
          //     "url(" + require("assets/img/register_bg_2.png").default + ")",
          // }}
          ></div>
          <Switch>
            <Route path="/auth/login" exact component={Login} />
            <Route path="/auth/register" exact component={Register} />
            <Route path="/auth/forgot-password" exact component={ForgotPassword} />
            <Route path="/auth/reset-password/:token" exact component={ResetPassword}/>
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
          <FooterSmall absolute backgroundColor={backgroundColor}/>
        </section>
      </main>
    </>
  );
}
